<template>
  <div class="app-content" style="display: flex;background-color: #fff;padding: 20px;" ref="appContent">
    <div style="width: 400px;margin-right: 10px;flex:none;">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" class="query-form" ref="queryForm">
        <el-form-item label-width="0" label="">
          <el-input v-model="dataForm.name" placeholder="模板名称" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" size="mini">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('trade:bomtemplate:save')" size="mini" type="primary"
                     @click="addOrUpdateHandle()">
            {{ $t('add') }}
          </el-button>
        </el-form-item>
      </el-form>
      <el-table ref="mainTable" v-loading="dataListLoading" :data="dataList" border style="width: 100%;" @row-click="selRowHandle" :height="maxTableHeight" :highlight-current-row	="true" current-row-key	="id">
        <el-table-column type="index" label="行号" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="name" label="模板名称" header-align="center"  min-width="150">
          <template slot-scope="scope">
            {{ scope.row.name }}【{{ scope.row.creatorName }}】
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('trade:bomtemplate:update')" type="text" size="small"
                       icon="el-icon-edit-outline"
                       @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
            </el-button>
            <el-button v-if="$hasPermission('trade:bomtemplate:delete')" type="text" size="small"
                       icon="el-icon-close"
                       @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="flex:1;">
      <el-table v-if="currentRow&&currentRow.detailList" :data="currentRow.detailList" border style="width: 100%;margin-top: 42px;">
        <el-table-column
            type="index"
            width="50"
            label="行号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column label="原料名称" align="center" prop="name">
        </el-table-column>
        <el-table-column
            label="颜色"
            prop="color"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column
            label="规格"
            prop="size"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column label="幅宽" header-align="center" align="center" prop="attr1">
        </el-table-column>
        <el-table-column label="克重" header-align="center" align="center" prop="attr2">
        </el-table-column>
        <el-table-column label="数量" header-align="center" align="center" prop="count">
        </el-table-column>
      </el-table>
    </div>
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './add-or-update'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/bom/template/list',
        getDataListIsPage: false,
        exportURL: '/trade/bomtemplate/export',
        deleteURL: '/trade/bom/template',
        deleteIsBatch: true
      },
      maxTableHeight: 100,
      currentRow: null,
      dataForm: {
        name: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    afterTableBinding(dataList){
      if(dataList&&dataList.length>0){
        this.$refs.mainTable.setCurrentRow(dataList[0])
        this.selRowHandle(dataList[0])
      }
    },
    selRowHandle (row) {
      if(row.detailList&&typeof row.detailList==='string'){
        row.detailList = JSON.parse(row.detailList)
      }
      this.currentRow = row

    }
  },
  mounted () {
    this.$nextTick(() => {
      this.maxTableHeight=this.$refs.appContent.clientHeight -
          this.$refs.queryForm.$el.clientHeight
    })
  }
}
</script>
